<template>
    <div class="edit">
        <div class="edit_top">
            <div class="go_back"></div>
            <div class="edit_name">绑定支付宝账号</div>
        </div>
        <div class="edit_account">
            <div class="account_user">
                <span class="user_name">姓  &nbsp;&nbsp;名：</span>
                <input type="text" maxlength="15" class="username" placeholder="请输入你的真实姓名" >
            </div>
            <div class="account_ali">
                <span class="account_name">支付宝：</span>
                <input type="text" class="account_email" placeholder="建议填写邮箱账号" >
            </div>
        </div>
        <div class="edit_exp">
            <div class="edit_name">温馨提示</div>
            <div class="edit_tit">1.收款姓名请填写实名，不要填昵称，否则打款失败.</div>
            <div class="edit_tit">2.收款账号若填写错误，可重新填写提交</div>
            <div class="edit_tit">3.提现过程中遇到任何问题都可联系客服</div>
            <div class="edit_advise">建议填写邮箱支付宝账号，手机支付宝账号易出现多个支付宝</div>
        </div>
        <div class="edit_true">点击确认</div>
    </div>
</template>
<script>
    export default {
        name: 'Bind',
        data () {
             return {

             }
        },
    }
</script>
<style scoped>
.edit{width:100%;height:100%;background:#F8F8F8;position: relative;}
.edit_top{width:100%;height:80px;background:#FFE514;padding-top:40px;background-size:100% 100%;display: flex;justify-content: flex-start;}
.edit_top .go_back{width:48px;height:48px;background:url(/static/images/team_go_back.png) no-repeat center center;background-size:100% 100%;margin-left:20px;}
.edit_top .edit_name{color:#333333;font-size:34px;font-weight:600;margin-left:194px;}
.edit_account{width:698px;height:204px;background:#FFF;margin:0 auto;border-radius:20px;margin-top:24px;}
.edit_account input{border:none;width:500px;line-height:80px;}
.account_user{width:644px;height:102px;margin:0 auto;border-bottom:2px solid #F2F2F2;line-height:102px;font-size:28px;color:#000000;font-weight:bold;}
.account_ali{width:644px;height:100px;margin:0 auto;line-height:100px;font-size:28px;color:#000000;font-weight:bold;}
.edit_exp{width:698px;height:310px;padding-top:30px;margin:0 auto;background:#FFF;margin-top:20px;border-radius:20px;}
.edit_exp div{width:560px;padding-left:28px;}
.edit_exp .edit_name{font-size:28px;color:#FF0000;margin-bottom:4px;}
.edit_exp .edit_tit{font-size:24px;color:#9B9B9B;margin-top:8px;}
.edit_exp .edit_advise{color:#FF0000;font-size:24px;line-height:40px;margin-top:8px;}
.edit_true{width:698px;height:100px;background:#FFE514;border-radius:50px;line-height:100px;text-align: center;font-size:32px;color:#333334;position: absolute;left:0; right:0;bottom:26px;margin:auto;}
</style>


// WEBPACK FOOTER //
// src/components/person/bind.vue